import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/BoxArrowDown.es.js";
const r = o.forwardRef((e, n) => /* @__PURE__ */ o.createElement(t, { ref: n, ...e, weights: a }));
r.displayName = "BoxArrowDownIcon";
const s = r;
export {
  r as ArchiveBoxIcon,
  s as BoxArrowDown,
  r as BoxArrowDownIcon
};
